import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSite } from '../../contexts/SiteContext';
import CertifiedSiteList from '../../components/CertifiedSiteList';
import { mockCertifiedSites } from '../../data/certifiedSites';
import { CertifiedSite as CertifiedSiteType } from '../../types';

// 스타일 컴포넌트
const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
  background-color: white;
  border-radius: 10px;
`;

const PageHeader = styled.div`
  margin-bottom: 2rem;
`;

const PageTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.5rem;
  text-align: center;
`;

const PageDescription = styled.p`
  color: #6b7280;
  font-size: 0.875rem;
  line-height: 1.5;
  text-align: center;
`;

const CertifiedSitePage: React.FC = () => {
  const [sites, setSites] = useState<CertifiedSiteType[]>([]);
  const { siteConfig } = useSite();

  useEffect(() => {
    // 실제 API 연동 시 여기에서 데이터를 가져오고, 
    // 지금은 전체 목업 데이터를 표시
    setSites(mockCertifiedSites);
  }, []);

  return (
    <PageContainer>
      <PageHeader>
        <PageTitle>{siteConfig.siteName} 공식 제휴 사이트</PageTitle>
        <PageDescription>
          {siteConfig.siteName}에서 엄선한 안전한 공식 제휴 사이트입니다. <br/>
          모든 사이트는 보증금 예치 및 철저한 검증을 거쳐 선정되었습니다.
        </PageDescription>
      </PageHeader>
      
      <CertifiedSiteList 
        sites={sites} 
        showHeader={false} 
        columns={10}
      />
    </PageContainer>
  );
};

export default CertifiedSitePage; 